import { useGlobalSearch } from '../providers/GlobalSearchProvider'

export const GlobalSearchView = () => {
  useGlobalSearch()

  return null
}
